// Run this example by adding <%= javascript_pack_tag 'hello_react' %> to the head of your layout file,
// like app/views/layouts/application.html.erb. All it does is render <div>Hello React</div> at the bottom
// of the page.

import React from 'react'
import ReactDOM from 'react-dom'
import App from './AppRoot';

document.addEventListener('DOMContentLoaded', () => {
  const appRoot = document.createElement('div');
  appRoot.setAttribute("id", 'appRoot');
  ReactDOM.render(
    <App name="React" />,
    document.body.appendChild(appRoot),
  )
})